<table>
  <tbody>
    <tr>
      <th>Qty</th>
      <th>Each</th>
      <th>Total</th>
    </tr>
    <tr>
      <td>
        <input *ngIf="product.qtyBoxStyle == 'input'" class="rounded" type="number" mbnmQty min="1" [(ngModel)]="product.project.qty" />
        <select *ngIf="product.qtyBoxStyle == 'select'" class="rounded" [(ngModel)]="product.project.qty">
          @for (qty of product.qtyBoxValues; track qty) {
          <option>{{ qty }}</option>
          }
        </select>
      </td>
      <td class="unit-price-container">
        <div class="unit-price" *ngIf="!product.project.qty">
          <span class="currency">?</span>
        </div>
        <div class="unit-price" *ngIf="product.project.qty > 0">
          <span class="currency" [innerHtml]="product.project.price | currency2"></span>
        </div>
      </td>
      <td class="unit-price-container">
        <div class="unit-price" *ngIf="product.project.qty > 0">
          <s *ngIf="product.project.price != product.project.maxPrice" [innerHtml]="product.project.maxPrice * product.project.qty | currency2"></s>
          <span class="currency" [ngClass]="{cents: product.project.qty * product.project.price < 1}" [innerHtml]="product.project.qty * product.project.price | currency2"></span>
          <span class="savings" *ngIf="product.project.price != product.project.maxPrice">
            Save {{(1 - product.project.price / product.project.maxPrice) | percent:'1.0-0'}}
          </span>
        </div>
        <div class="unit-price" *ngIf="!product.project.qty">
          <span class="currency">?</span>
        </div>
      </td>
    </tr>
  </tbody>
</table>
